import React from "react";
import "./AboutPage.css";
import ProfilePic from "../assets/profile.jpg";


function AboutPage() {
  return (
    <div className="about-container">

      {/* HEADER SECTION */}
      <section className="about-hero">
        <h1>About This Platform</h1>
        <p>
          A modern AI-powered testing and productivity assistant designed for QA Engineers.
          This platform automates repetitive tasks, analyzes bugs, generates test cases,
          and boosts quality engineering workflows using intelligent AI models.
        </p>
      </section>

      {/* ABOUT YOU */}
<section className="about-section about-profile">
  <h2>👨‍💻 About the Creator</h2>

  <img
    src={ProfilePic}
    alt="Atiqur Rahman"
    className="profile-pic"
  />

  <p>
    Hi, I'm <strong>Atiqur Rahman</strong>, a QA Automation Engineer specializing in
    building scalable automation frameworks and AI-enhanced testing tools.
    This platform demonstrates real-world experience across frontend, backend,
    automation, DevOps, and AI integration.
  </p>

  {/* ✅ INSERT VIDEO RIGHT HERE */}
  <div className="about-video">
    <h3 className="sub-heading">🎥 MSTest Automation Demo</h3>
    <video
      controls
      playsInline
      preload="metadata"
      className="demo-video"
    >
      <source src="/tutorials/mstest-run.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>

  <h3 className="sub-heading">💼 Technical Skills</h3>

  <ul className="skill-list">
    <li><strong>Frontend:</strong> HTML, CSS, JavaScript, DHTML, JSON</li>
    <li><strong>Backend:</strong> MySQL, MS SQL Server, Microservices</li>
    <li><strong>Automation Tools:</strong> Selenium, Playwright</li>
    <li><strong>DevOps:</strong> Git, Azure DevOps, Azure Repos, CI/CD Pipelines</li>
    <li><strong>Testing:</strong> TDD, BDD, Data-driven testing, Cross-browser testing, Mobile testing</li>
    <li><strong>Methodologies:</strong> Agile / Scrum, SSO authentication workflows</li>
  </ul>
</section>


      {/* PROJECT TECH STACK */}
      <section className="about-section">
        <h2>🛠️ Technologies Used in This Project</h2>
        <p>This platform is built with a modern and scalable full-stack architecture:</p>

        <ul className="skill-list">
          <li><strong>Frontend:</strong> React.js (Components, Hooks, Routing)</li>
          <li><strong>Backend:</strong> Node.js + Express API</li>
          <li><strong>AI Models:</strong> OpenAI API (NLP)</li>
          <li><strong>Styling:</strong> Custom CSS with responsive layout</li>
          <li><strong>State Management:</strong> React Hooks & component composition</li>
          <li><strong>Architecture:</strong> Modular folder structure for scalability</li>
          <li><strong>Future Testing Framework:</strong> Selenium + Page Object Model (POM)</li>
        </ul>
      </section>

      {/* PURPOSE */}
      <section className="about-section">
        <h2>🚀 Mission & Purpose</h2>
        <ul className="purpose-list">
          <li>✨ AI-driven test case generation</li>
          <li>✨ Automatic bug severity classification</li>
          <li>✨ Automated Selenium/POM script generation</li>
          <li>✨ AI-powered test execution summaries</li>
          <li>✨ QA-focused AI chatbot</li>
        </ul>
      </section>

      {/* CONTACT */}
      <section className="contact-section">
        <h2>📬 Contact</h2>
        <p>You can reach me here:</p>

        <div className="contact-links">
          
          <a
            href="https://github.com/arahman247"
            target="_blank"
            rel="noopener noreferrer"
          >
            💻 GitHub
          </a>

          <a href="mailto:Atiqurqa347@gmail.com">
            📧 Email Me
          </a>
        </div>
      </section>

    </div>
  );
}

export default AboutPage;
